import React from "react";
import { NavLink } from "react-router-dom";
import { navItems } from "../../data/navgation";

// import "./NavigationItems.css";

const NavigationItems = (props) => [
  navItems.map((item) => (
    <li key={item.id} className="navigation-item">
      <NavLink to={item.path} onClick={props.onClick} className="a">
        {item.text}
      </NavLink>
    </li>
  )),
];

export default NavigationItems;
